export default __webpack_public_path__ + "static/media/storageUnit1-afterA-2048w.9dd67fa2.avif";